import { Box, type CSSObject, Stack, styled, Typography } from '@mui/material';
import { Button } from '../../../components/Rumblefish23Theme/Button';

export const StyledStack = styled(Stack)(({ theme }) => ({
  maxWidth: '600px',
  minHeight: '254px',
  margin: theme.spacing(10, 0, 16),
  [theme.breakpoints.down('md')]: {
    width: '324px',
  },
}));
export const ButtonWrapper = styled(Box)(({ theme }) => ({
  transition: 'all 0.4s ease-in-out',
  marginTop: theme.spacing(6),
}));
export const StyledCompany = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  transition: 'all 0.4s ease-in-out',
}));

export const StyledTitle = styled(Typography)<{ isActive: boolean }>(
  ({ theme, isActive }) => ({
    ...(isActive
      ? ({
          ...(theme.mixins.neutralGradient as CSSObject),
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
        } as CSSObject)
      : ({
          color: theme.palette.invertedContent?.SECONDARY,
        } as CSSObject)),
    letterSpacing: '-0.02em',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      alignSelf: 'center',
    },
  })
);

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.raspberryColors?.PLUS_2} inset !important`,
  },
}));
